import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateService } from '@ngx-translate/core';
import { Role } from 'src/app/entities/role';
import { AuthService } from 'src/app/services/auth.service';
import { CategoryService } from 'src/app/services/category.service';
import { SharedService } from 'src/app/services/sharedService';
import { UserService } from 'src/app/services/user.service';
import * as MenuItems from './menuItems';
import { CompanyDexieService } from 'src/app/services/companyDexie-services/companyDexie.service';
import { SynchronizeService } from 'src/app/services/synchronize.service';
import { CompanyRepresentativeService } from 'src/app/services/companyRepresentative.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { IssueTrackerDialogComponent } from '../dialogs/issue-tracker-dialog/issue-tracker-dialog.component';

@Component({
  selector: 'tas-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css']
})
export class TopMenuComponent implements OnInit, OnDestroy {
  selectedMun = []
  title: string = "TAS-GOV";
  lang: string;
  username: string;
  userrole: Role;
  initials: string;
  menuItems: (string | boolean)[][];
  currentUser
  filterData = { municipality: null };
  singleMunicipality
  munFull = 'COMMON-TOP-MENU.SEARCH-MUNICIPALITY'
  munEmpty = ''
  isOnline: boolean = true;
  unmatchedCount
  unmatchedCountSubscription: any
  synchronizationInProgress = false;
  private destroy$ = new Subject<void>();
  menuItemsTest = MenuItems.ChildRoutes
  constructor(
    public auth: AuthService,
    public jwtHelper: JwtHelperService,
    public sharedService: SharedService,
    public translate: TranslateService,
    public router: Router,
    public userService: UserService,
    public categoryService: CategoryService,
    private breakpointObserver: BreakpointObserver,
    private companyDexieService: CompanyDexieService,
    private synchronizeService: SynchronizeService,
    private companyRepresentaiveService: CompanyRepresentativeService,
    private dialog: MatDialog
  ) {
    this.initializeUserData();
  }

  isMenuItemActive(menuItemPath: string): boolean {
    const currentUrl = this.router.url.split('?')[0];
    let menuItem = this.menuItemsTest.find(elem => elem.parent === menuItemPath)
    if (menuItem?.children?.find(el => el === currentUrl)) {
      return true
    }
    return currentUrl === menuItemPath;
  }

  async initializeUserData() {
    const token = this.jwtHelper.tokenGetter();
    if (token && token !== 'undefined') {
      const decodedToken = this.jwtHelper.decodeToken(token);

      this.lang = localStorage.getItem("default_lang") || 'fr';
      this.username = decodedToken.username;
      this.initials = decodedToken.initials;
      this.userrole = Role[decodedToken.role + ''];
      this.menuItems = MenuItems.MenuCategories.get(Role[this.userrole]);
    }
    this.unmatchedCount = await this.companyRepresentaiveService.getUnmatchedRequestsCount().toPromise()
    this.unmatchedCountSubscription = this.sharedService.tinMatchEmmitter.subscribe(async val => {
      this.unmatchedCount = await this.companyRepresentaiveService.getUnmatchedRequestsCount().toPromise()
    })
  }
  isSmallScreen(): boolean {
    return this.breakpointObserver.isMatched('(min-width: 420px)');
  }

  isLargeScreen(): boolean {
    return this.breakpointObserver.isMatched('(min-width: 1450px)');
  }
  setLang(lang) {
    this.sharedService.setLan(lang);
    this.lang = lang;
    this.translate.use(lang);
  }

  openIssueTracker() {
    this.dialog.open(IssueTrackerDialogComponent, {
      width: '850px',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container'
    });
  }

  async logout() {
    this.username = undefined;
    await this.auth.logout();
    this.router.navigate(['login']);
    localStorage.removeItem('municipality')
    localStorage.removeItem('municipalityName')
    localStorage.removeItem('municipalityBbox')
  }
  selectChange = (event: any) => {
    let municipality
    if (event.data.length > 0) {
      municipality = event.data[0]
      localStorage.setItem('municipality', event.data[0].id)
      localStorage.setItem('municipalityBbox', event.data[0].bbox)
      localStorage.setItem('municipalityName', event.data[0].name)
    }
    else {
      localStorage.removeItem('municipalityBbox')
      localStorage.removeItem('municipalityName')
      localStorage.removeItem('municipality')
    }
    this.sharedService.changeMunicipality(municipality)
  };
  async ngOnInit() {
    this.currentUser = await this.userService.getCurrentUser().toPromise()
    this.sharedService.onlineStatus$.pipe(takeUntil(this.destroy$)).subscribe(async status => {
      this.isOnline = status;
      if (this.isOnline) {
        const userMunicipality = this.currentUser?.municipalities?.[0];
        const municipality = userMunicipality?.id;
        if (!municipality) {
          return;
        }
        const mun = userMunicipality?.offline !== undefined
          ? userMunicipality
          : await this.categoryService.getCategory('municipality', municipality).toPromise();

        const dbExists = await this.companyDexieService.databaseExists('tasdb')
        if (this.isOnline && (this.currentUser?.role === 'SECRETARY_ASSISTANT' || dbExists)) {
          let synchDate = await this.companyDexieService.getLatestSynchronization()
          if (dbExists && this.currentUser?.role !== 'SECRETARY_ASSISTANT' && synchDate === undefined && !mun?.offline) {
            return
          }
          if (!synchDate?.synchronizationDate || synchDate?.synchFlag || this.sharedService.shouldSynchronize(synchDate.synchronizationDate)) {
          this.synchronizationInProgress = true
            let payments = await this.companyDexieService.getAllPayments()
            for (let payment of payments) {
              await this.synchronizeService.remoteSynchronize(payment).toPromise()
            }
            if (this.currentUser?.role !== 'SECRETARY_ASSISTANT' || !mun?.offline) {
              await this.companyDexieService.clearDatabase()
              this.synchronizationInProgress = false
            }
            else {
              setTimeout(async () => {
                await this.synchronizeService.localSynchronize(this.currentUser)
                this.synchronizationInProgress = false
              }, 3000)

            }
          }
        }
      }
    });
    if (this.currentUser) {
      if (this.currentUser.role !== 'ADMIN' && this.currentUser.municipalities && this.currentUser.municipalities.length === 1) {
        this.singleMunicipality = this.currentUser.municipalities[0].name
        localStorage.setItem('municipality', this.currentUser.municipalities[0].id)
        localStorage.setItem('municipalityName', this.currentUser.municipalities[0].name)
      }
    }
    const municipalityList = await this.categoryService.getList("municipality").toPromise()
    if (municipalityList) {
      this.filterData["municipality"] = municipalityList.map((fld) => ({
        name: fld.name,
        id: fld.id,
        bbox: fld.bbox
      }));
      this.filterData["municipality"].unshift({ name: 'ALL', id: -1 })
      this.sharedService.setMunicipalities(municipalityList)
    }
    if (localStorage.getItem('municipality') && localStorage.getItem('municipalityName')) {
      this.selectedMun = this.filterData['municipality'].filter(elem => elem.id === localStorage.getItem('municipality'))
      if (!localStorage.getItem('municipalityBbox') && this.selectedMun.length > 0) {
        const municipalityBbox = await this.categoryService.getCategory('municipality', this.selectedMun[0]['id']).toPromise()
        if (municipalityBbox) {
          this.selectedMun[0].bbox = municipalityBbox.bbox
          localStorage.setItem('municipalityBbox', municipalityBbox.bbox)
        }
      }
    }
  }
  ngOnDestroy(): void {
    if (this.unmatchedCountSubscription) this.unmatchedCountSubscription.unsubscribe()
  }
  getPlaceHolder() {
    if (localStorage.getItem('municipality') && localStorage.getItem('municipalityName')) {
      return this.munEmpty
    }
    return this.munFull
  }
}
